/** @format */
import React, { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import Loader from '@components/loader';
import { TranslationProvider } from '@context/translation-context';

const SearchPage = lazy(
  () => import(/* webpackChunkName: "search-page" */ './search-page')
);

/**
 * Build Events page.
 */
export const searchPage = (): void => {
  /**
   * Full events page (new).
   */

  const searchPage: HTMLElement | null = document.getElementById('search-page');
  if (searchPage) {
    const root = createRoot(searchPage);
    root.render(
      <Suspense fallback={<Loader />}>
        <TranslationProvider>
          <SearchPage />
        </TranslationProvider>
      </Suspense>
    );
  }
};
